import { createSelector } from '@ngrx/store';

import { modalsState } from '../root';

export const getAllModals = createSelector(
    modalsState,
    (modals: OLO.State.Modals) => modals
);
